import React from 'react';

import { StyledYatHand } from '@pkg/components/Sections/Groups/GroupHeader/GroupHeaderImage/styles';

import { GroupItemAvatarBadge } from '../../../GroupItemAvatarBadge';
import {
    GroupItemAvatar,
    GroupItemAvatarBackground,
    GroupItemAvatarHolder,
    GroupItemAvatarImage,
    GroupItemAvatarPlaceholder,
} from '../../../styles';
import { type GroupItemProps } from '../../../types';

import { GroupItemMobileName, GroupItemMobileWrapper } from './styles';

export const GroupItemMobile = ({ name, avatarUrl, isOwner, isMember, privacy, onClick }: GroupItemProps) => {
    const isPrivate = privacy === 'Private';

    return (
        <GroupItemMobileWrapper onClick={onClick}>
            <GroupItemAvatar isPrivate={isPrivate}>
                <GroupItemAvatarHolder isPrivate={isPrivate}>
                    {avatarUrl ? (
                        <GroupItemAvatarImage avatarUrl={avatarUrl} />
                    ) : (
                        <GroupItemAvatarPlaceholder>
                            <StyledYatHand />
                        </GroupItemAvatarPlaceholder>
                    )}
                </GroupItemAvatarHolder>
                {isPrivate && <GroupItemAvatarBackground />}
                {(isOwner || isMember) && <GroupItemAvatarBadge type={isOwner ? 'owner' : 'member'} />}
            </GroupItemAvatar>
            <GroupItemMobileName title={name}>{name}</GroupItemMobileName>
        </GroupItemMobileWrapper>
    );
};
